import { render, staticRenderFns } from "./RecipientSearch.vue?vue&type=template&id=4e0c8d4f"
import script from "./RecipientSearch.vue?vue&type=script&lang=js"
export * from "./RecipientSearch.vue?vue&type=script&lang=js"
import style0 from "./RecipientSearch.vue?vue&type=style&index=0&id=4e0c8d4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports